<template>
    <div class="container stretch">
        <div class="columns is-centered">
            <div v-if="language === 'it'" @click="select( 'online' )" class="column is-half has-text-centered type-selector"
                 :class="{ 'selected': type === 'online' }">
                <div class="inner">
                    <img class="image" src="/images/quote_online.svg"
                         :alt="lang('Calcola Preventivo Online')">
                    <div class="text">
                        <span class="title"><span v-html="titleQuote"></span></span>
                        <span class="subtitle">
                            {{ lang('(Superfici inferiori a 200 MQ)') }}<br>
                            {{ lang('Tempo di ricezione:') }} <strong v-text="lang('immediato')"></strong>
                        </span>
                    </div>
                </div>
            </div>
            <div @click="select( 'request' )" class="column is-half has-text-centered type-selector"
                 :class="{ 'selected': type === 'request' }">
                <div class="inner">
                    <img class="image" src="/images/quote_request.svg" alt="Richiedi Preventivo">
                    <div class="text">
                        <span class="title"><span v-html="titleRequest"></span></span>
                        <span class="subtitle">
                            {{ lang('(Superfici maggiori di 200 MQ)') }}<br>
                            {{ lang('Tempo di ricezione:') }} <strong v-text="lang('7 giorni')"></strong></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            value: {
                type: String,
                required: false
            }
        },
        mounted() {
            if( typeof this.value === 'string' ) this.assignTypeFromValue()
        },
        data() {
            return {
                type: false
            }
        },
        methods: {
            select( type ) {
                this.type = type;
                this.$emit('input', type);
                this.$emit('completed');
            },
            assignTypeFromValue() {
                this.type = ( this.value === 'online' || this.value === 'request' ) ? this.value : false
            }
        },
        watch: {
            value() {
                this.assignTypeFromValue();
            }
        },
        computed: {
            titleQuote() {
                return this.lang('Calcola preventivo<br>\"On-Line\"');
            },
            titleRequest() {
                return this.lang('Richiedi preventivo<br>\"Ufficio Commerciale\"')
            },
            language() {
                return window.language;
            }
        }
    }
</script>